import { useMutation, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import toast from 'react-hot-toast'
import { createUsers } from 'services/apiUsers'

const useAddUsers = () => {
    
    const queryClient = useQueryClient()

  const{isPending, isSuccess, isError, mutate: addUsers} = useMutation({
    mutationFn: createUsers,
    onSuccess:(data)=>{
        queryClient.setQueryData(["newUser"],data)
        console.log("data on AddUsers, on success",data)
        queryClient.invalidateQueries({queryKey:['userList']})
        toast.success("User added sucessfully")
    },
    onError:(error)=>{
        console.log("Error occurred add users",error)
        if (error?.data && typeof error.data === 'object') {
        // Display all backend validation errors
        for (const key in error.data) {
            const msg = error.data[key];
            toast.error(Array.isArray(msg) ? msg[0] : msg);
        }
      } else {
          toast.error(error.message || "Something went wrong.");
      }
    }
  })

  return{isPending,isSuccess,isError,addUsers}
}

export default useAddUsers